import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api/api';

import { SET_RECEIVE_USERS } from '../../utils/common/constant';

const ActionType = {
  SET_RECEIVE_USERS,
};

const receiveUsersActionCreator = (users) => {
  return {
    type: ActionType.SET_RECEIVE_USERS,
    payload: {
      users,
    },
  };
};

const asyncRegisterUser = ({ name, email, password }) => {
  return async (dispatch) => {
    dispatch(showLoading());

    try {
      await api.register({ name, email, password });
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

export {
  ActionType,
  receiveUsersActionCreator,
  asyncRegisterUser,
};
